import api from './api';
import { Tier, CreateTierRequest, UpdateTierRequest } from '../types';

export const tierService = {
  getAll: async (): Promise<Tier[]> => {
    const response = await api.get('/tiere');
    return response.data;
  },
  // All animals of a grave (several may share a grave, now and over time).
  getAllByGrab: async (grabId: number): Promise<Tier[]> => {
    const response = await api.get(`/tiere?grabId=${grabId}`);
    return response.data;
  },
  getByGrab: async (grabId: number): Promise<Tier | null> => {
    const response = await api.get(`/tiere?grabId=${grabId}`);
    const list: Tier[] = response.data;
    return list.length > 0 ? list[0] : null;
  },
  getById: async (id: number): Promise<Tier> => {
    const response = await api.get(`/tiere/${id}`);
    return response.data;
  },
  create: async (data: CreateTierRequest): Promise<Tier> => {
    const response = await api.post('/tiere', data);
    return response.data;
  },
  update: async (id: number, data: UpdateTierRequest): Promise<Tier> => {
    const response = await api.put(`/tiere/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/tiere/${id}`);
  }
};

export default tierService;
